'use strict';

var Ad = require('./Ad');
var VASTError = require('./VASTError');
var VASTResponse = require('./VASTResponse');
var vastUtil = require('./vastUtil');

var async = require('../../utils/async');
var http = require('../../utils/http').http;
var utilities = require('../../utils/utilityFunctions');
var xml = require('../../utils/xml');

var logger = require ('../../utils/consoleLogger');

function VASTClient(options) {
  if (!(this instanceof VASTClient)) {
    return new VASTClient(options);
  }
  var defaultOptions = {
    WRAPPER_LIMIT: 5
  };

  options = options || {};
  this.settings = utilities.extend({}, options, defaultOptions);
  this.errorURLMacros = [];
}

VASTClient.prototype.getVASTResponse = function getVASTResponse(adTag, usePods, callback) { // adTag - url or Tree {pods: [], stand_alone: []} 
  var that = this;
  this.adsChain = adTag && adTag.wrappersChain && adTag.wrappersChain.slice(0) || []; // use previuos for pods or new

  var error = sanityCheck(adTag, callback);
  if (error) {
    if (utilities.isFunction(callback)) {
      return callback(error);
    }
    throw error;
  }

  async.waterfall([
      this._getVASTAd.bind(this, adTag, usePods),
      buildVASTResponse
    ],
    callback);

  /*** Local functions ***/
  function buildVASTResponse(adsChain, ads, cb) {
    try {
      var response = that._buildVASTResponse(adsChain); // наслоение в глубину (по wrapper)
      cb(null, response, ads);
    } catch (e) {
      cb(e);
    }
  }

  function sanityCheck(adTagUrl, cb) {
    if (!adTagUrl) {
      return new VASTError('on VASTClient.getVASTResponse, missing ad tag URL or Ad tree');
    }

    if (!utilities.isFunction(cb)) {
      return new VASTError('on VASTClient.getVASTResponse, missing callback function');
    }
  }
};

VASTClient.prototype._getVASTAd = function (adTag, usePods, callback) {
  var that = this;

  if (utilities.isString(adTag)) { // url
    getAdWaterfall(adTag, function (error, vastTree) {
      var waterfallAds = vastTree && utilities.isArray(vastTree.ads) ? vastTree.ads : null;
      if (error) {
        that._trackError(error, waterfallAds);
        return callback(error, waterfallAds);
      }
      getAdTreeCb(waterfallAds, groupAds.bind(that));

    });
  } else { // part of Tree {pods: [], stand_alone: []}
    getAdTreeCb(adTag);
  }

  function getAdTreeCb(waterfallAds) {
    var ad, respAds, resSelAd;

    if (utilities.isString(adTag)) { // first init
      resSelAd = selectAdToGet(waterfallAds, usePods);
      respAds = resSelAd.respAds;
      ad = resSelAd.ad;
    } else { // use prev pods chain
      ad = waterfallAds.pods.shift();
    }

    getAd(ad, adTag.wrappersChain && adTag.wrappersChain.slice(0) || [], {}, waterfallHandler);  

    /*** Local functions ***/
    function waterfallHandler(error, adChain, wrapperedRespAds) {
      if (error) {
        that._trackError(error, adChain);
        var fb_ad = selectFallbackAd(adChain);
        if (fb_ad) {
          getAd(fb_ad, [], {}, waterfallHandler);
        } else {
          callback(error, adChain);
        }
      } else {
        var adsTrain = insertIntoAdsTrain(adChain, wrapperedRespAds);
        callback(null, adChain, adsTrain);
      }
    }

    function selectFallbackAd(adChain) {
      var useStandAlone,
        res_ad,
        wa = utilities.isString(adTag) ? (respAds || {}) : waterfallAds; // first init or prev pods 

      if (usePods) {
        if ((adChain[adChain.length-1] || '').wrapper) { // no ad from wrapper
          useStandAlone = getWrapperAttrs(adChain[adChain.length-1]).fallbackOnNoAd;
          if (useStandAlone) res_ad = wa.stand_alone.shift();
        } else {
          res_ad = wa.pods.shift();
        }
      } else {
        res_ad = (wa.stand_alone || []).shift();
      }
      return res_ad;
    }

    function insertIntoAdsTrain(adChain, wrapperedRespAds) {
      if (!wrapperedRespAds && !respAds) return;

      var res_train = {
          pods: [], 
          stand_alone: [], 
          wrappersChain: adChain.slice(0, -1)
        };

      if (wrapperedRespAds) {
        res_train.pods = res_train.pods.concat(wrapperedRespAds.pods);
        res_train.stand_alone = res_train.stand_alone.concat(wrapperedRespAds.stand_alone);
      }

      if (respAds) {
        res_train.pods = res_train.pods.concat(respAds.pods);
        res_train.stand_alone = res_train.stand_alone.concat(respAds.stand_alone);
      }

      return res_train;
    }
  }

  function selectAdToGet(adsTree, usePod) {
    var ad,
      respAds,
      typedAds = groupAds(adsTree);

    if (usePod) {
      ad = typedAds.pods.shift();
      respAds = {
        pods: typedAds.pods.slice(0), 
        stand_alone: typedAds.stand_alone.slice(0)
      };
    }
    if (!ad) { // fallback - play first found
      ad = typedAds.stand_alone.shift();
    }

    if (!ad && !usePods) {//  fallback - try to play first found (not by standart?)
      ad = typedAds.pods.shift();
    }
    return {ad: ad, respAds: respAds};
  }



  function groupAds(ads) {
    var res = {pods: [], stand_alone: []};
    ads.forEach(function(ad){
      if (parseInt(xml.attr(ad, 'sequence'))) {
        res.pods.push(ad);
      } else {
        res.stand_alone.push(ad);
      }
    });
    res.pods.sort(function(a, b) {
      return xml.attr(a, 'sequence') - xml.attr(b, 'sequence'); 
    });
    return res;
  }

  function getWrapperAttrs(ad) {
    var res, wr = ad.wrapper;

    if (wr) {
      res = {
        allowMultipleAds: wr.allowMultipleAds && wr.allowMultipleAds !== 'false' && wr.allowMultipleAds !== '0',
        fallbackOnNoAd:  wr.fallbackOnNoAd && wr.fallbackOnNoAd !== 'false' && wr.fallbackOnNoAd !== '0'
      };
    }
    return res;
  }


  /*** Local functions ***/
  function getAdWaterfall(adTagUrl, callback) {
    var requestVastXML = that._requestVASTXml.bind(that, adTagUrl);
    async.waterfall([
      requestVastXML,
      buildVastWaterfall
    ], callback);
  }

  function buildVastWaterfall(xmlStr, callback) {
    var vastTree;
    try {
      vastTree = xml.toJXONTree(xmlStr);
      logger.debug ("built JXONTree from VAST response:", vastTree);

      if(utilities.isArray(vastTree.ad)) {
        vastTree.ads = vastTree.ad;
      } else if(vastTree.ad){
        vastTree.ads = [vastTree.ad];
      } else {
        vastTree.ads = [];
      }
      callback(validateVASTTree(vastTree), vastTree);

    } catch (e) {
      callback(new VASTError("on VASTClient.getVASTAd.buildVastWaterfall, error parsing xml", 100), null); 
    }
  }

  function validateVASTTree(vastTree) {
    var vastVersion = xml.attr(vastTree, 'version');

    if (!vastTree.ad) {
      var err_code = that.adsChain.length ? 303 : 'EMPTY_AD'; // 303 - for wrapper only: no ad after one or more wrapper calls 
      var err = new VASTError('on VASTClient.getVASTAd.validateVASTTree, no Ad in VAST tree', err_code);
      // send error for linear 
      vastTree.error && that._trackError(err, [{error: vastTree.error.keyValue}]);
      return err;
    }

    if (vastVersion && (vastVersion != 3 && vastVersion != 2)) {
      return new VASTError('on VASTClient.getVASTAd.validateVASTTree, not supported VAST version "' + vastVersion + '"', 102);
    }

    return null;
  }

  function getAd(adTagUrl, adChain, wrapperAttrs, callback) {
    if (adChain.length >= that.WRAPPER_LIMIT) {
      return callback(new VASTError("on VASTClient.getVASTAd.getAd, players wrapper limit reached (the limit is " + that.WRAPPER_LIMIT + ")", 302), adChain);
    }

    async.waterfall([
      function (next) {
        if (utilities.isString(adTagUrl)) {
          requestVASTAd(adTagUrl, wrapperAttrs, next);
        } else {
          next(null, adTagUrl, null);
        }
      },
      buildAd
    ], function (error, ad, wrapperedRespAds) {
      if (ad) {
        adChain.push(ad);
        that.adsChain.push(ad); 
      }

      if (error) {
        return callback(error, adChain);
      }

      if (ad.wrapper) {
        return getAd(ad.wrapper.VASTAdTagURI, adChain, getWrapperAttrs(ad), callback);
      }

      return callback(null, adChain, wrapperedRespAds);
    });
  }

  function buildAd(adJxonTree, wrapperedRespAds, callback) {
    try {
      var ad = new Ad(adJxonTree);
      callback(validateAd(ad), ad, wrapperedRespAds);
    } catch (e) {
      callback(new VASTError('on VASTClient.getVASTAd.buildAd, error parsing xml', 100), null);
    }
  }

  function validateAd(ad) {
    var wrapper = ad.wrapper;
    var inLine = ad.inLine;
    var errMsgPrefix = 'on VASTClient.getVASTAd.validateAd, ';

    if (inLine && wrapper) {
      return new VASTError(errMsgPrefix +"InLine and Wrapper both found on the same Ad", 101);
    }

    if (!inLine && !wrapper) {
      return new VASTError(errMsgPrefix + "nor wrapper nor inline elements found on the Ad", 101);
    }

    if (inLine && !inLine.isSupported()) {
      return new VASTError(errMsgPrefix + "could not find MediaFile that is supported by this video player", 403);
    }

    if (wrapper && !wrapper.VASTAdTagURI) {
      return new VASTError(errMsgPrefix + "missing 'VASTAdTagURI' in wrapper", 101);
    }

    return null;
  }

  function requestVASTAd(adTagUrl, wrapperAttrs, callback) {
    that._requestVASTXml(adTagUrl, function (error, xmlStr) {
      if (error) {
        return callback(error);
      }
      try {
        var vastTree = xml.toJXONTree(xmlStr),
          ad, respAds, selAdRes;

        if(utilities.isArray(vastTree.ad)) {
          vastTree.ads = vastTree.ad;
        } else if(vastTree.ad){
          vastTree.ads = [vastTree.ad];
        } else {
          vastTree.ads = [];
        }

        selAdRes = selectAdToGet(vastTree.ads, usePods && !!wrapperAttrs.allowMultipleAds);
        ad = selAdRes.ad;
        respAds = selAdRes.respAds;

        callback(validateVASTTree(vastTree), ad, respAds); // мб массив, а дб одно  
      } catch (e) {
        callback(new VASTError("on VASTClient.getVASTAd.requestVASTAd, error parsing xml", 100));
      }
    });
  }

};

VASTClient.prototype._requestVASTXml = function requestVASTXml(adTagUrl, callback) {
  try {
    if (utilities.isFunction(adTagUrl)) {
      adTagUrl(requestHandler);
    } else {
      logger.info ("requesting adTagUrl: " + adTagUrl);
      http.get(adTagUrl, requestHandler, {
        withCredentials: true
      });
    }
  } catch (e) {
    callback(e);
  }

  /*** Local functions ***/
  function requestHandler(error, response, status) {
    if (error) {
      var errMsg = utilities.isDefined(status) ?
      "on VASTClient.requestVastXML, HTTP request error with status '" + status + "'" :
        "on VASTClient.requestVastXML, Error getting the the VAST XML with he passed adTagXML fn";
      return callback(new VASTError(errMsg, 301), null);
    }

    callback(null, response);
  }
};

VASTClient.prototype._buildVASTResponse = function buildVASTResponse(adsChain) {
  var response = new VASTResponse();
  addAdsToResponse(response, adsChain);
  validateResponse(response);

  return response;

  //*** Local function ****
  function addAdsToResponse(response, ads) {
    ads.forEach(function (ad) {
      response.addAd(ad);
    });
  }

  function validateResponse(response) {
    var progressEvents = response.trackingEvents.progress;

    if (!response.hasLinear()) {
      throw new VASTError("on VASTClient._buildVASTResponse, Received an Ad type that is not supported", 200);
    }

    if (response.duration === undefined) {
      throw new VASTError("on VASTClient._buildVASTResponse, Missing duration field in VAST response", 101);
    }

    if (progressEvents) {
      progressEvents.forEach(function (progressEvent) {
        if (!utilities.isNumber(progressEvent.offset)) {
          throw new VASTError("on VASTClient._buildVASTResponse, missing or wrong offset attribute on progress tracking event", 101);
        }
      });
    }
  }
};

VASTClient.prototype._trackError = function (error, adChain) {
  if (!utilities.isArray(adChain) || adChain.length === 0) { //There is nothing to track
    vastUtil.trackGa('fail_' + (error.code || 900));
    return;
  }

  var errorURLMacros = [];
  adChain.forEach(addErrorUrlMacros);
  vastUtil.track(errorURLMacros, {ERRORCODE: error.code != 'EMPTY_AD' && error.code || 900});  //900 <== Undefined error
  vastUtil.trackGa('error_' + (error.code != 'EMPTY_AD' && error.code || 900));

  /*** Local functions  ***/
  function addErrorUrlMacros(ad) {
    if (ad.error) {
      errorURLMacros.push(ad.error);
    }

    if (ad.wrapper && ad.wrapper.error) {
      errorURLMacros.push(ad.wrapper.error);
    }

    if (ad.inLine && ad.inLine.error) {
      errorURLMacros.push(ad.inLine.error);
    }
  }
};

module.exports = VASTClient;
